/* Support for dual colors menu */

const initMenuColors = () => {
  const menuClipItems = document.querySelectorAll(".Header--clip-parent");

  const clipObjects = [];

  let highestTop = 10000;
  let lowestBottom = 0;

  menuClipItems.forEach((item) => {
    const clip = item.getBoundingClientRect();

    if (clip.top < highestTop) {
      highestTop = clip.top;
    }
    if (clip.bottom > lowestBottom) {
      lowestBottom = clip.bottom;
    }

    const obj = {
      top: clip.top,
      bottom: clip.bottom,
      clip: item.querySelector(".Header--clip"),
    };

    clipObjects.push(obj);
  });

  const menuClipSections = document.querySelectorAll(".Section--clip-menu");

  if (menuClipSections.length === 0) {
    clipObjects.forEach((obj) => {
      obj.clip.style.clipPath = `inset(0 0 100% 0)`;
    });
    return;
  }
  document.addEventListener("scroll", onScroll);
  onScroll();

  function onScroll(e) {
    let closest = menuClipSections[0];
    let closestDistance = 10000;
    menuClipSections.forEach((item) => {
      // get current section
      const section = item.getBoundingClientRect();

      const topDistance = Math.abs(section.top - lowestBottom);
      const bottomDistance = Math.abs(section.bottom - highestTop);
      const minDistance = Math.min(topDistance, bottomDistance);

      if (minDistance < closestDistance) {
        closest = item;
        closestDistance = minDistance;
      }
    });

    let section = closest.getBoundingClientRect();

    if (section.top < lowestBottom && section.bottom > highestTop) {
      clipObjects.forEach((obj) => {
        const objDiff = obj.clip.closest(".TorqueClone") != null ? -16 : 0;
        const height = obj.bottom - obj.top;

        const topClip = ((section.top - obj.top + objDiff) / height) * 100;
        const bottomClip =
          ((obj.bottom - section.bottom + objDiff) / height) * 100;

        const topClipped = Math.abs(topClip) < Math.abs(bottomClip);

        obj.clip.style.clipPath = topClipped
          ? `inset(${topClip}% 0 0 0)`
          : `inset(0 0 ${bottomClip}% 0)`;
      });
    }

    if (section.top > lowestBottom) {
      clipObjects.forEach((obj) => {
        obj.clip.style.clipPath = `inset(100% 0 0 0)`;
      });
    }

    if (section.bottom < highestTop) {
      clipObjects.forEach((obj) => {
        obj.clip.style.clipPath = `inset(0 0 100% 0)`;
      });
    }
  }
};

// initMenuColors(); moved to global to work with wack effect
subscribe(PUB_SUB_EVENTS.menuReady, function (data) {
  initMenuColors();
});

function initMenuHide (){
  const menu = document.querySelector(".Header");
  const announcementBar = document.querySelector(".Announcement-Bar");

  let lastScrollTop = 0;
  window.addEventListener("scroll", () => {
    const currentScrollTop = window.pageYOffset || document.documentElement.scrollTop;

    if (currentScrollTop > lastScrollTop) {
      // Scrolling down
      menu.classList.add("Header--hidden");
    } else {
      // Scrolling up
      menu.classList.remove("Header--hidden");
    }

    if(currentScrollTop < 100) {
      menu.classList.remove("Header--hidden");
      announcementBar.classList.remove("Announcement-Bar--hidden");
      menu.style.setProperty("--header-top", `${announcementBar.offsetHeight}px`);
    }
    else{
      announcementBar.classList.add("Announcement-Bar--hidden");
      menu.style.setProperty("--header-top", "0px");
    }

    lastScrollTop = currentScrollTop <= 0 ? 0 : currentScrollTop; // For mobile or negative scrolling
  });

  const currentScrollTop = window.pageYOffset || document.documentElement.scrollTop;

  if(currentScrollTop < 100) {
    menu.classList.remove("Header--hidden");
    announcementBar.classList.remove("Announcement-Bar--hidden");
    menu.style.setProperty("--header-top", `${announcementBar.offsetHeight}px`);
  }
  else{
    announcementBar.classList.add("Announcement-Bar--hidden");
    menu.style.setProperty("--header-top", "0px");
  }

}

initMenuHide();

function initMobileMenu() {
  const mobileMenu = document.querySelector(".MobileMenu");
  const mobileMenuButton = document.querySelector('[data-event="toggle-mobile-menu"]');
  const mobileMenuCloseButton = document.querySelector('[data-event="close-mobile-menu"]');

  mobileMenuButton.addEventListener("click", (e) => {
    e.preventDefault();
    mobileMenu.classList.toggle("Open");
  });

  mobileMenuCloseButton.addEventListener("click", (e) => {
    e.preventDefault();
    mobileMenu.classList.remove("Open");
  });

  window.addEventListener("click", (e) => {
    if (!mobileMenu.contains(e.target) && !mobileMenuButton.contains(e.target)) {
      mobileMenu.classList.remove("Open");
    }
  });
}

initMobileMenu();